module.exports = __webpack_public_path__ + "img/banner3.957d3449.png";